import React from 'react';
import classnames from 'classnames';
import * as styles from './styles.module.scss';

import { Link } from 'gatsby';

import Icon from 'components/UI/Icon';

const PartnerInfo = ({ subHeader, btns, comment, benefits }) => (
  <div className={styles.info}>
    <div className={styles.info_top}>
      <p className={classnames('cr-text-3 cr-subheader', styles.info_suptitle)}>
        {subHeader}
      </p>

      <p className={styles.info_comment}>{comment}</p>
    </div>

    <div className={styles.info_center}>
      <ul className={styles.info_benefits}>
        {benefits.map((benefit, i) => (
          <li key={i}>
            <div className={styles.info_benefit}>
              <span className={classnames('cr-h5', styles.info_benefit_type)}>
                {benefit.type}
              </span>
              <span className={classnames('cr-reg', styles.info_benefit_desc)}>
                {benefit.text}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>

    <div>
      <div className={styles.info_btns}>
        {btns.map((btn, i) => (
          <Link
            key={i}
            to={btn.to}
            className={classnames(
              'cr-btn cr-btn--icon cr-btn--large cr-btn--wide',
              {
                'cr-btn--icon-red-bg': i % 2 === 0,
              }
            )}
          >
            {btn.txt}
            <Icon name="corner-arrow-small-bold" />
          </Link>
        ))}
      </div>
    </div>
  </div>
);

export default PartnerInfo;
